@import "tailwindcss";

/* Theme tokens. Indigo accent; dark is the hero theme. `data-theme` on <html>
   is set by useTheme: "dark" | "light" | absent (absent = follow system). */
@theme {
  --color-accent: #4f46e5;
  --color-accent-strong: #6366f1;
}

/* Dark is the base theme (lives directly on :root, no data-theme="dark" block).
   data-theme="light" and the prefers-color-scheme:light query override it. */
:root {
  --bg: #0e0e11;
  --surface: #18181b;
  --border: #27272a;
  --text: #f4f4f5;
  --muted: #a1a1aa;
}
:root[data-theme="light"] {
  --bg: #fafafa;
  --surface: #ffffff;
  --border: #ececec;
  --text: #18181b;
  --muted: #71717a;
}
@media (prefers-color-scheme: light) {
  :root:not([data-theme="dark"]) {
    --bg: #fafafa;
    --surface: #ffffff;
    --border: #ececec;
    --text: #18181b;
    --muted: #71717a;
  }
}

html, body, #root { height: 100%; }
body {
  margin: 0;
  background: var(--bg);
  color: var(--text);
  font-family: system-ui, -apple-system, sans-serif;
}
